// Centralized configuration for the Sales Professional
export const repConfig = {
  name: "Nicole Stewart",
  title: "Senior Sales Consultant",
  phone: "(216) 926-5466",
  phoneClean: "2169265466",
  experience: "12+ Years Experience",
  tagline: "Personally helping families find the right vehicle since 2013.",
};